import { Form, Formik } from 'formik';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import authApis from '../../../APIs/auth';
import logo from '../../../assets/icons/logo.svg';
import mail from '../../../assets/icons/Mail.svg';
import {
  Button,
  FormContainer,
  Input,
  Typography,
} from '../../../designComponents';
import { CHANGE_PASSWORD_ROUTE } from '../../../routes/routePaths';
import theme from '../../../theme';
import { requestAPI } from '../../../utils';
import {
  ContentContainer,
  Heading,
  Label,
  LoginContainer,
  Logo,
} from './style';
import { ForgotPasswordSchema } from './validationSchema';

const ForgetPassword = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const handleForgetPassword = async (values: { email: string }) => {
    try {
      setLoading(true);
      await requestAPI(authApis.forgotPassword(values.email));
      toast.success('OTP sent to your email, please check your mail');
      setLoading(false);
      navigate(`${CHANGE_PASSWORD_ROUTE}/?email=${values.email}`);
    } catch (error: any) {
      setLoading(false);

      console.log(error);
      toast.error(error);
    }
  };
  return (
    <LoginContainer>
      <ContentContainer>
        <Heading>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
          >
            <Typography variant="heading" strong>
              Evacuation Plans
            </Typography>
            <Typography style={{ marginLeft: '45px', color: '#3D3D3D' }}>
              SaaS Application
            </Typography>
          </div>
          <div>
            <Logo src={logo} alt="logo" />
          </div>
        </Heading>

        <Label>
          <Typography size={16} color={theme.colors.normalText}>
            Forgot Password ?
          </Typography>
        </Label>

        <Typography style={{ marginBottom: '15px' }}>
          Enter your email address we’ll sent a link to get back into your
          account.
        </Typography>
        <Formik
          initialValues={{
            email: '',
          }}
          onSubmit={handleForgetPassword}
          enableReinitialize
          validationSchema={ForgotPasswordSchema}
        >
          {({ values, setFieldValue, errors, handleSubmit, touched }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <FormContainer
                  label="Email Address"
                  error={touched?.email ? errors.email : ''}
                  marginBottom="20px"
                >
                  <Input
                    name="email"
                    value={values.email}
                    onChange={(e) => setFieldValue('email', e.target.value)}
                    placeholder="Enter email"
                    iconLeft={<img src={mail} alt="mail icon" />}
                  />
                </FormContainer>

                <Button
                  htmlType="submit"
                  variant="primary"
                  size="lg"
                  width="100%"
                  style={{ marginBottom: '15px' }}
                  isLoading={loading}
                >
                  Continue
                </Button>
              </Form>
            );
          }}
        </Formik>
      </ContentContainer>
    </LoginContainer>
  );
};

export default ForgetPassword;
